import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { saveAndGetQuotaSavedColumns } from '../../../common/endpoints';

export const savedQuotaColumns = createApi(saveAndGetQuotaSavedColumns, 'GET');

const SavedColumns = createSlice({
  name: 'SavedColumns',
  initialState: {
    data: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(savedQuotaColumns.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(savedQuotaColumns.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(savedQuotaColumns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SavedColumns.reducer;